import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative inline-block text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "-mr-1 ml-2 h-5 w-5",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_3 = {
  key: 0,
  class: "origin-top-center absolute mt-2 w-full rounded-md shadow-lg bg-white border focus:outline-none z-10",
  role: "menu",
  "aria-orientation": "vertical",
  "aria-labelledby": "menu-button",
  tabindex: "-1"
}
const _hoisted_4 = {
  class: "py-1",
  role: "none"
}
const _hoisted_5 = ["onClick"]

import { ref } from "vue";
import { IDropdown } from "@/IDropdown";

interface MyDropdownProps {
  list?: IDropdown[];
  current?: IDropdown;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    list: null,
    current: null
  },
  emits: ["selected"],
  setup(__props: any, { emit }) {

const isOpen = ref(false);





function onSelected(item: any) {
  emit("selected", item);
  isOpen.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value)),
        type: "button",
        class: "inline-flex justify-center w-full rounded-md border shadow-sm px-4 py-3 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500",
        id: "menu-button",
        "aria-expanded": "true",
        "aria-haspopup": "true"
      }, [
        _createTextVNode(" language : " + _toDisplayString(__props.current?.name), 1),
        _hoisted_2
      ])
    ]),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (lang) => {
              return (_openBlock(), _createElementBlock("button", {
                href: "#",
                class: "text-gray-700 block px-4 py-2 text-sm hover:bg-palette5 hover:text-white w-full z-10",
                role: "menuitem",
                tabindex: "-1",
                id: "menu-item-0",
                onClick: ($event: any) => (onSelected(lang)),
                key: lang.name
              }, _toDisplayString(lang.name), 9, _hoisted_5))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})